export default __webpack_public_path__ + "static/media/93@2x-8.6ab6ac55.png";